module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAY1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+aRQ2gAAAAIHRSTlMAw4dKaaWckHfp3NKwJCAPzLV4WfX0uqqViH5nUUA+O2gI/0cAAAB8SURBVCjPrdBHDgIxEETRapuxcRomkGPf/5Qg1DJys0Fi/vZJtSgsXMdNB0iWVVbAaXACSUMS2GnYCkQNUeCefTkP43VPc06n3o8P1ApqPT7diAfjgvOhM8Q0VVhxE/0C7+HMPAPHBjZymQXMn+DXr+IXXFjSUEIDE5btCYMiF9jQbu4xAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_datainput_active.png
// module id = yZZS
// module chunks = 9